import React from 'react';

class OffersPageMain extends React.Component {
  render(){
    return(
      <div>
        Offers page
      </div>
    );
  }
}

export default OffersPageMain
